module.exports = "<div class=\"container\" [title]=\"getTooltip()\" #Cont >\r\n    <input  class=\"input\" \r\n            [ngClass]=\"{'comment-icon' : !value.length}\"\r\n            (focusout)=\"focusOut(Input.value)\" \r\n            (keyup.enter)=\"focusOut(Input.value)\"\r\n            [(ngModel)]=\"value\" \r\n            #Input>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/input-comment/inputComment.component.html
// module id = ./src/app/shared/input-comment/inputComment.component.html
// module chunks = main